module.exports = "<div id=\"footer\">\n\n  <img src=\"assets/img/iso.png\" alt=\"MasterBus\">\n\n</div>\n"